// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3296":"23eb0ecd","8349":"23eb0ecd"}[chunkId] + ".chunk.css";
};